import script from "./CardIndicador.vue?vue&type=script&setup=true&lang=js"
export * from "./CardIndicador.vue?vue&type=script&setup=true&lang=js"

import "./CardIndicador.vue?vue&type=style&index=0&id=3d761ae9&lang=scss&scoped=true"

import exportComponent from "C:\\developmentGIT\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AccessIntegrationSite\\access-integration\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d761ae9"]])

export default __exports__